import { ImageType } from '../../data/types/files';
import {
  CLEAR,
  SET_LAST_FETCHED_SILAL_IMAGES,
  SET_LAST_FETCHED_STORE_IMAGES,
  SET_SILAL_IMAGES,
  SET_STORE_IMAGES,
} from './image_library_actions';

export const initialState: {
  silal_images: ImageType[];
  store_images: ImageType[];
} = {
  silal_images: [],
  store_images: [],
};

export const Images = (state = initialState, action: any) => {
  if (action.type === SET_SILAL_IMAGES) {
    return { ...state, silal_images: action.payload };
  }
  if (action.type === SET_STORE_IMAGES) {
    return { ...state, store_images: action.payload };
  }

  if (action.type === SET_LAST_FETCHED_SILAL_IMAGES) {
    return { ...state, lastFetchedSilalImages: action.timestamp };
  }

  if (action.type === SET_LAST_FETCHED_STORE_IMAGES) {
    return { ...state, lastFetchedStoreImages: action.timestamp };
  }

  if (action.type === CLEAR) {
    return {};
  }

  return state;
};
